import DefaultLayout from "../layouts/defaultLayout";
import Background from "../layouts/background";

const layouts = {
  default: DefaultLayout,
  background: Background,
};

export default layouts;
